import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { EventType } from '@azure/msal-browser';
import { msal } from './auth/msal.js';
import { configured } from './config.js';
import { startSync } from './offline/index.js';
import { startLinkListeners } from './native/links.js';
import { startPushListeners } from './native/push.js';
import { startLiveUpdates } from './native/updates.js';
import App from './App.jsx';
import '@fontsource/barlow/400.css';
import '@fontsource/barlow/600.css';
import '@fontsource/barlow/700.css';
import '@fontsource/barlow-condensed/700.css';
import './styles.css';

async function boot() {
  // Before anything else, so the notification or link that opened the app is caught.
  startPushListeners();
  await startLinkListeners();
  startLiveUpdates();
  if (configured) {
    await msal.initialize();
    const result = await msal.handleRedirectPromise().catch(() => null);
    const account = result?.account || msal.getActiveAccount() || msal.getAllAccounts()[0];
    if (account) msal.setActiveAccount(account);
    msal.addEventCallback((e) => {
      if (e.eventType === EventType.LOGIN_SUCCESS && e.payload?.account) msal.setActiveAccount(e.payload.account);
    });
    if (account) startSync();
  }

  createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <MsalProvider instance={msal}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MsalProvider>
    </React.StrictMode>,
  );
}

boot();
